// Designer stage views: loading spinner, product-picker placeholder, and canvas init kickoff.

import { store } from '../../core/store.js'
import { createLogger } from '../../utils/logger.js'
import { initDesigner } from './sds/sdk-init.js'
import { resolvePreloadProduct } from './preload.js'

const log = createLogger('design')

/**
 * Show loading state in the design mode panel
 */
export function showDesignLoading(text = 'Loading Design SDK...') {
  const container = document.getElementById('sds-container')
  if (!container) return

  // Show the container first
  container.style.display = 'flex'

  const designerEl = document.getElementById('designer-container')
  if (designerEl) {
    designerEl.innerHTML = `
      <div class="design-loading">
        <div class="spinner"></div>
        <div class="design-loading-text">${text}</div>
      </div>
    `
  }
}

/**
 * Show product picker placeholder
 */
export function showProductPicker() {
  const container = document.getElementById('sds-container')
  if (!container) return
  container.style.display = 'flex'

  const designerEl = document.getElementById('designer-container')
  if (designerEl) {
    designerEl.innerHTML = `
      <div class="design-loading">
        <i class="ph ph-t-shirt" style="font-size: 48px; color: var(--text-muted); margin-bottom: 12px;"></i>
        <div class="design-loading-text">Select a product to start designing</div>
        <button class="design-start-btn" id="designStartBtn">
          Start designing
        </button>
      </div>
    `
    // Bind quick-start button. With no hardcoded default we try the live
    // catalog's first listed product; if that fails too, tell the user to pick
    // one from the Products panel rather than init the SDK with an invalid id.
    const btn = document.getElementById('designStartBtn')
    if (btn) {
      btn.onclick = async () => {
        const product = await resolvePreloadProduct()
        if (product?.id) {
          store.setState('design.currentProduct', product)
          startDesign(product.id)
        } else {
          const textEl = container.querySelector('.design-loading-text')
          if (textEl) textEl.textContent = 'Please select a product from the Products panel to start designing'
        }
      }
    }
  }
}

/**
 * Start design with a product
 */
export async function startDesign(productId) {
  try {
    showDesignLoading('Initializing canvas...')
    await initDesigner(productId)
  } catch (error) {
    log.error('Failed to start design:', error)
    const designerEl = document.getElementById('designer-container')
    if (designerEl) {
      designerEl.innerHTML = `
        <div class="design-loading">
          <i class="ph ph-warning" style="font-size: 48px; color: var(--state-danger); margin-bottom: 12px;"></i>
          <div class="design-loading-text">Failed to initialize designer</div>
          <div style="font-size: 12px; color: var(--text-muted); margin-top: 4px;">${error.message}</div>
          <button class="design-start-btn" onclick="location.reload()">Retry</button>
        </div>
      `
    }
  }
}
